import cx from 'classnames';
import Field from '../components/ui/field';
import Button from '../components/ui/button';

import styles from '../styles/formBox.scss';

interface FormBoxProps {
  name: string;
  onChange: any;
  button?: any;
  title: string;
  loading?: boolean;
  onSubmit: any;
  value?: any;
  type?: string;
  error?: any;
  megaError?: string;
  className?: string;
  forgotPasswordLink?: boolean;
  placeholder?: string;
  autoFocus?: boolean;
  email?: string;
  emailValidationStatus?: string;
  startClicksCount?: number;
}

const FormBox = (props: FormBoxProps) => (
  <form
    action="#"
    className={cx(props.className || 'row', 'paper')}
    onSubmit={props.onSubmit}
  >
    {props.megaError && (
      <h3 className={cx(styles['mega-error'])}>
        Sorry, this phone / email is not registered with us. Please check or try
        using your associated email id.
      </h3>
    )}
    {(props.name === 'login' || props.name === 'register') && (
      <input
        type="email"
        value={props.email}
        style={{ display: 'none' }}
        key="hidden-email-field"
        readOnly
      />
    )}
    <Field
      name={props.name}
      labelName={props.title}
      type="text"
      fieldType={props.type || 'text'}
      id={props.name}
      ref={(field: any) => (this.field = field)}
      className={cx('large-12 columns', styles['email-field'])}
      value={props.value}
      isInvalid={!props.megaError && props.error ? true : false}
      validationMessage={!props.megaError && props.error}
      onChange={props.onChange}
      placeholder={props.placeholder || props.name}
      autoFocus={true}
      required={true}
    />
    {props.emailValidationStatus === 'invalid' ? (
      <p className={cx('large-12 columns', styles['emailError'])}>
        This does not look like a common/ valid email ID. Please check the email
        ID you've entered.
      </p>
    ) : props.emailValidationStatus === 'unknown' ? (
      <p className={cx('large-12 columns', styles['emailError'])}>
        &#128161; We suggest that you use a personal email ID and avoid office/
        work email ID.
      </p>
    ) : null}
    {props.button && (
      <div className="large-12 columns mt10">
        <Button
          loadingLabel={props.button.loadingLabel}
          label={props.button.label}
          disabled={props.loading}
          onClick={props.onSubmit}
          className="ct-btn ct-btn--medium ct-btn--green full-width mb10"
        />
      </div>
    )}
  </form>
);

export default FormBox;



// WEBPACK FOOTER //
// ./components/FormBox.tsx